import { VueModule } from '@Foundation';
import DateOfBirth from './dateOfBirth/code/Scripts/components/date-of-birth.vue';
import FieldSelect from './fields/FieldSelect/code/Scripts/components/field-select';
import FormItem from './FormItem/code/Scripts/components/form-item';
import FormGroup from './FormGroup/code/Scripts/components/form-group';
import FieldTextarea from './fields/FieldTextarea/code/Scripts/components/field-textarea';
import FieldRadio from './fields/FieldRadio/code/Scripts/components/field-radio';
import FieldInput from './fields/FieldInput/code/Scripts/components/field-input';
import FieldHelp from './fields/FieldHelp/code/Scripts/components/field-help';
import FieldCheckbox from './fields/FieldCheckbox/code/Scripts/components/field-checkbox';
import CustomFormNewsLetter from './CustomFormNewsLetterSubscription/code/Scripts/components/custom-form-newsletter.vue';
import CustomFormContact from './CustomFormContact/code/Scripts/components/custom-form-contact.vue';
import CustomFormRegister from './CustomFormRegister/code/Scripts/components/custom-form-register';
import CustomFormLogin from './CustomFormLogin/code/Scripts/components/custom-form-login';
import CustomFormEditPassword from './CustomFormEditPassword/code/Scripts/components/custom-form-edit-password';
import CustomFormForgotPassword1 from './CustomFormForgotPassword1/code/Scripts/components/custom-form-forgot-password-1';
import CustomFormForgotPassword2 from './CustomFormForgotPassword2/code/Scripts/components/custom-form-forgot-password-2';
import CustomFormPersonalInfo from './CustomFormPersonalInfo/code/Scripts/components/custom-form-personal-info';
import CustomCrmNewsletterSubscription from './CustomCrmNewsletterSubscription/code/Scripts/components/custom-crm-newsletter-subscription.vue'

export default VueModule({
    components: {
        DateOfBirth,
        FieldSelect,
        FieldRadio,
        FieldTextarea,
        FieldInput,
        FieldHelp,
        FieldCheckbox,
        CustomFormNewsLetter,
        CustomCrmNewsletterSubscription,
        CustomFormContact,
        CustomFormRegister,
        CustomFormLogin,
        CustomFormEditPassword,
        CustomFormForgotPassword1,
        CustomFormForgotPassword2,
        CustomFormPersonalInfo,
        FormItem,
        FormGroup
    }
});